"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendDonationItemSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var unitsList_1 = require("common/global/unitsList");
var formik_1 = require("formik");
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var productsList_1 = require("common/global/productsList");
var warehouseConsumeOperationsSlice_1 = require("src/features/warehouseConsumeOperations/warehouseConsumeOperationsSlice");
exports.SendDonationItemSchema = Yup.object().shape({
    to: Yup.string().required(),
});
function ConsumeManyItemsDialog(props) {
    var _this = this;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var commonInfo = antd_1.Form.useForm()[0];
    var itemsInfo = antd_1.Form.useForm()[0];
    var modalState = props.modalState, warehouseItems = props.warehouseItems, setModalState = props.setModalState;
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)([]), values = _b[0], setValues = _b[1];
    var _c = (0, react_1.useState)(undefined), index = _c[0], setIndex = _c[1];
    var dateOfNow = (0, moment_1.default)();
    var nonExpiredItems = warehouseItems
        .filter(function (e) {
        if (e.expiryDate == null) {
            return true;
        }
        else {
            return (0, moment_1.default)(e.expiryDate) >= dateOfNow || e.expiryDate === undefined;
        }
    })
        .filter(function (e) { return e.quantity > 0; });
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = (0, react_1.useState)(false), uploading = _d[0], setUploading = _d[1];
    (0, react_1.useEffect)(function () {
        if (index == values.length) {
            setLoading(false);
            setModalState(undefined);
        }
    }, [index]);
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            to: "",
            products: [],
            SRAttachment: "",
            SRNumber: "",
        },
        validationSchema: exports.SendDonationItemSchema,
        onSubmit: function (values, form) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(values.products.length == 0)) return [3 /*break*/, 1];
                        antd_1.message.error("Form Not Valid!");
                        return [3 /*break*/, 3];
                    case 1:
                        setLoading(true);
                        return [4 /*yield*/, Promise.all(values.products.map(function (item, inx) {
                                var _a, _b, _c;
                                var productObj = warehouseItems.find(function (x) { return x.stockNumber === item.stockNumber; });
                                var product = productsList_1.globalProductsData[productObj.productId];
                                var sameProducts = productObj;
                                var quantity = item.quantity;
                                if (sameProducts.quantity === 0) {
                                    throw new Error("QuantityMustBePositive");
                                }
                                if (sameProducts.quantity < quantity) {
                                    //  TODO update the error
                                    throw new Error("QuantityMustBePositive");
                                }
                                else {
                                    var _d = lodash_1.zip.apply(void 0, ((_a = item.serialNumbers) !== null && _a !== void 0 ? _a : []).map(function (x) { return x.split(":"); })), serialNumbers = _d[0], assetsNumbers = _d[1];
                                    var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
                                    dispatch((0, warehouseConsumeOperationsSlice_1.consumeWarehouseItem)({
                                        item: __assign(__assign({}, values), { projectId: productObj.projectId, productId: productObj.productId, stockNumber: item.stockNumber, batchNumber: sameProducts.batchNumber, warehouseId: props.warehouseId, budgetLineId: sameProducts.budgetLineId, expiryDate: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.expiryDate, dnNumber: (_b = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.dnNumber) !== null && _b !== void 0 ? _b : "", from: (_c = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.from) !== null && _c !== void 0 ? _c : "", id: sameProducts.id, quantity: sameProducts.quantity }),
                                        product: product,
                                        quantity: product.serialNumbered
                                            ? item.serialNumbers.length
                                            : quantity,
                                        serialNumbers: product.serialNumbered ? serialNumbers : [],
                                        assetsNumbers: product.serialNumbered ? assetsNumbers : [],
                                        userId: userId,
                                    }));
                                    //   dispatch(
                                    //     addConsumeOperation(
                                    //       removeUndefined({
                                    //         to: values.to,
                                    //         warehouseId: props.warehouseId,
                                    //         projectId: productObj.projectId,
                                    //         productId: productObj.productId,
                                    //         stockNumber: item.stockNumber,
                                    //         batchNumber: sameProducts?.batchNumber,
                                    //         serialNumbers: product.serialNumbered ? serialNumbers : [],
                                    //         assetsNumbers: product.serialNumbered ? assetsNumbers : [],
                                    //         quantity: product.serialNumbered
                                    //           ? item.serialNumbers.length
                                    //           : quantity,
                                    //         createdAt: moment() as any,
                                    //         cachedProductName: product.name,
                                    //         cachedProductUnit: product.unitId,
                                    //         cachedProductDescription: product.description,
                                    //         notes: item.notes ?? "",
                                    //         sentBy: userId,
                                    //         sentAt: moment() as any,
                                    //         cachedProductCategory: product.categoryId,
                                    //         budgetLineId: sameProducts.budgetLineId,
                                    //         SRAttachment: values.SRAttachment,
                                    //         SRNumber: values.SRNumber,
                                    //         expiryDate: sameProducts.expiryDate,
                                    //         updatedAt: moment() as any,
                                    //         consumedBy: userId,
                                    //         before: sameProducts.quantity,
                                    //         after: sameProducts.quantity - quantity,
                                    //       } as WarehouseConsumeOperation)
                                    //     )
                                    //   );
                                    //   const newQuantity = sameProducts.quantity - quantity;
                                    //   if (newQuantity < 0) {
                                    //     // transaction.delete(warehouseItemsRef.doc(sameProducts.id))
                                    //     message.error("الكمية المصروفة اكبر من الكمية الحالية!");
                                    //   } else {
                                    //     dispatch(
                                    //       editWarehouseItem({
                                    //         id: productObj.id,
                                    //         quantity: newQuantity,
                                    //         serialNumbers: sameProducts?.serialNumbers
                                    //           ? sameProducts?.serialNumbers?.filter(
                                    //               (x) => !serialNumbers.includes(x)
                                    //             )
                                    //           : [], // TODO: no need to delete one of the serialnumbers
                                    //         assetsNumbers: sameProducts?.assetsNumbers
                                    //           ? sameProducts?.assetsNumbers?.filter(
                                    //               (x) => !assetsNumbers.includes(x)
                                    //             )
                                    //           : [],
                                    //       } as WarehouseItem)
                                    //     );
                                    //   }
                                }
                                setIndex(inx + 1);
                            }))
                                .then(function () {
                                form.resetForm();
                                itemsInfo.resetFields();
                                antd_1.message.success("Done");
                            })
                                .catch(function (e) { return console.log(e); })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    var sameProductQuantity = function (productProps) {
        var _a;
        var sameProducts = warehouseItems.find(function (x) { return x.stockNumber === (productProps === null || productProps === void 0 ? void 0 : productProps.stockNumber); });
        var max = (_a = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.quantity) !== null && _a !== void 0 ? _a : 0;
        return max;
    };
    var sameProductSerialNumbers = function (productProps) {
        var sameProducts = warehouseItems.find(function (x) { return x.stockNumber === (productProps === null || productProps === void 0 ? void 0 : productProps.stockNumber); });
        var serialNumbers = (sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.serialNumbers) == undefined
            ? false
            : sameProducts.serialNumbers.length == 0
                ? false
                : true;
        return serialNumbers;
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ width: 1500, title: "Consume Many Items", open: modalState, confirmLoading: formProps.isSubmitting, okButtonProps: { disabled: uploading }, closable: false, footer: [
            (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure?", okText: "Yes", cancelText: "No", onConfirm: function () {
                    setModalState(undefined);
                } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, { children: "Cancel" }) })),
            (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", onClick: function () {
                    itemsInfo.submit();
                    formProps.submitForm();
                } }, { children: "Add" })),
        ] }, { children: loading ? ((0, jsx_runtime_1.jsx)(antd_1.Spin, {})) : ((0, jsx_runtime_1.jsxs)("div", { children: [" ", (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ form: commonInfo, labelCol: { span: 15 }, wrapperCol: { span: 30 }, layout: "inline" }, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Row, __assign({ style: { width: "100%" } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("to").touched) &&
                                        formProps.errors.to &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("to").touched) &&
                                        formProps.errors.to, label: t("warehouse.to") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { value: formProps.values.to, onChange: formProps.handleChange("to") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("SRNumber").touched) &&
                                        formProps.errors.SRNumber &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("SRNumber").touched) &&
                                        formProps.errors.SRNumber, label: t("warehouse.SRNumber"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { type: "text", value: formProps.values.SRNumber, onChange: formProps.handleChange("SRNumber") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("SRAttachment").touched) &&
                                        formProps.errors.SRAttachment &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("SRAttachment").touched) &&
                                        formProps.errors.SRAttachment, required: true })] })), (0, jsx_runtime_1.jsx)(antd_1.Row, { style: { width: "100%" } })] })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(antd_1.Divider, { orientation: "left", children: "Select Products" }), (0, jsx_runtime_1.jsx)(antd_1.Form, __assign({ form: itemsInfo, onFinish: function (values) {
                        return formProps.setFieldValue("products", values.products);
                    }, onValuesChange: function (x, y) {
                        setValues(y.products);
                    } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.List, __assign({ name: "products" }, { children: function (fields, _a) {
                            var add = _a.add, remove = _a.remove;
                            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [fields.map(function (_a, index) {
                                        var key = _a.key, name = _a.name, fieldKey = _a.fieldKey, restField = __rest(_a, ["key", "name", "fieldKey"]);
                                        return ((0, jsx_runtime_1.jsxs)(antd_1.Space, __assign({ style: { display: "flex", marginBottom: 8 }, align: "baseline" }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({}, restField, { name: [name, "stockNumber"], fieldKey: [fieldKey, "stockNumber"], rules: [
                                                        { required: true, message: "Missing stockNumber " },
                                                    ] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ filterOption: function (inputValue, option) {
                                                            var _a, _b;
                                                            return (((_b = (_a = option === null || option === void 0 ? void 0 : option.children.join("-")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.indexOf(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase())) >= 0);
                                                        }, showSearch: true, style: { width: "500px" }, placeholder: t("warehouse.stockNumber"), maxTagCount: 1 }, { children: nonExpiredItems.map(function (x) { return ((0, jsx_runtime_1.jsxs)(antd_1.Select.Option, __assign({ value: x.stockNumber }, { children: [x.cachedProductName, " -", " ", x.cachedProductUnitName, " -", " ", x.cachedProductDescription, " - ", x.stockNumber] }), x.stockNumber)); }) })) })), sameProductSerialNumbers(values[index]) ? null : ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({}, restField, { name: [name, "quantity"], fieldKey: [fieldKey, "quantity"], rules: [
                                                        { required: true, message: "Missing quantity" },
                                                    ] }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { style: { width: "150px" }, placeholder: "Quantity", type: "number", max: sameProductQuantity(values[index]), min: 0 }) }))), sameProductSerialNumbers(values[index]) ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({}, restField, { name: [name, "serialNumbers"], fieldKey: [fieldKey, "serialNumbers"], rules: [
                                                        {
                                                            required: true,
                                                            message: "Missing Serial Numbers",
                                                        },
                                                    ] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "250px" }, placeholder: "Serial Numbers", mode: "multiple", maxTagCount: isNaN(sameProductQuantity(values[index]))
                                                            ? 0
                                                            : sameProductQuantity(values[index]) }, { children: warehouseItems
                                                            .filter(function (x) { var _a; 
                                                        // x.productId === values[index]?.productId &&
                                                        // x.projectId === values[index]?.projectId &&
                                                        return x.stockNumber === ((_a = values[index]) === null || _a === void 0 ? void 0 : _a.stockNumber); })
                                                            .map(function (x) {
                                                            return x.serialNumbers.map(function (serial, idx) { return ((0, jsx_runtime_1.jsxs)(antd_1.Select.Option, __assign({ value: "".concat(serial, ":").concat(x.assetsNumbers[idx]) }, { children: [serial, "/", x.assetsNumbers[idx]] }), serial)); });
                                                        }) })) }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({}, restField, { name: [name, "notes"], fieldKey: [fieldKey, "notes"], rules: [
                                                        {
                                                            required: false,
                                                            message: "Missing Notes Numbers",
                                                        },
                                                    ] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { style: { width: "350px" }, placeholder: "Notes" }) })), (0, jsx_runtime_1.jsx)(icons_1.MinusCircleOutlined, { onClick: function () {
                                                        remove(name);
                                                    } }), warehouseItems
                                                    .filter(function (x) { var _a; return x.stockNumber === ((_a = values[index]) === null || _a === void 0 ? void 0 : _a.stockNumber); })
                                                    .map(function (x) {
                                                    var _a;
                                                    var unit = (_a = unitsList_1.globalUnitsData[x.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name;
                                                    return ((0, jsx_runtime_1.jsx)("h3", { children: "".concat(x.cachedProductName, "/ ").concat(x.cachedProductDescription, "/ ").concat(unit) }, x.id));
                                                }), (0, jsx_runtime_1.jsxs)("h3", __assign({ style: { color: "red" } }, { children: ["Duplicate:", warehouseItems.filter(function (x) { var _a; return x.stockNumber === ((_a = values[index]) === null || _a === void 0 ? void 0 : _a.stockNumber); }).length] }))] }), key));
                                    }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: { width: "25%" }, type: "dashed", onClick: function () { return add(); }, block: true, icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}) }, { children: "Add field" })) })] }));
                        } })) })), " "] })) })));
}
exports.default = ConsumeManyItemsDialog;
